import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FullscreenModalPageRoutingModule } from './fullscreen-modal-routing.module';

import { FullscreenModalPage } from './fullscreen-modal.page';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ComponentsModule,
    FullscreenModalPageRoutingModule
  ],
  declarations: [FullscreenModalPage]
})
export class FullscreenModalPageModule {}
